import React from "react";
import { useApp } from "@/contexts/AppContext";

const SEV_COLOR = {
  critical: "var(--sev-critical)", high: "var(--sev-high)",
  medium: "var(--sev-medium)", low: "var(--sev-low)",
};

export default function SeverityBar({ data = [], testid = "severity-bar", compact = false }) {
  const { setSelectedDetail } = useApp();
  const total = data.reduce((a, x) => a + (x.count || 0), 0) || 1;
  const order = ["critical", "high", "medium", "low"];
  const sorted = order.map((s) => {
    const items = data.filter((x) => x.severity === s);
    const count = items.reduce((a, x) => a + (x.count || 0), 0);
    return { severity: s, count };
  });

  return (
    <div data-testid={testid} className="w-full">
      <div className={`flex items-center justify-between ${compact ? "mb-1" : "mb-1.5"}`}>
        {!compact ? (
          <span className="label-micro text-[var(--text-secondary)] uppercase tracking-widest">Signal Severity Distribution</span>
        ) : (
          <div className="flex items-center gap-2.5 overflow-x-auto no-scrollbar">
            {sorted.map((s) => (
              <div key={s.severity} className="flex items-center gap-1 whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: SEV_COLOR[s.severity] }} />
                <span className="text-[9px] font-medium uppercase tracking-tighter text-[var(--text-secondary)]">{s.severity}</span>
                <span className="text-[10px] font-display font-bold">{s.count}</span>
                <span className="text-[9px] opacity-40">({Math.round((s.count / total) * 100)}%)</span>
              </div>
            ))}
          </div>
        )}
        <span className="label-micro font-display whitespace-nowrap ml-2">Σ {total.toLocaleString()}</span>
      </div>
      <div className={`flex w-full ${compact ? "h-1.5" : "h-4"} border border-hair overflow-hidden bg-black/[0.03] rounded-full`}>
        {sorted.map((s) => {
          const pct = (s.count / total) * 100;
          if (pct <= 0) return null;
          return (
            <button
              type="button"
              key={s.severity}
              data-testid={`severity-segment-${s.severity}`}
              onClick={() => setSelectedDetail({ type: "severity", payload: { severity: s.severity, count: s.count } })}
              className="relative hover:opacity-90 transition-opacity cursor-pointer flex items-center justify-center overflow-hidden"
              style={{ width: `${pct}%`, background: SEV_COLOR[s.severity] }}
              title={`${s.severity}: ${s.count} (${Math.round(pct)}%)`}
            >
              {!compact && pct > 5 && (
                <span className="whitespace-nowrap text-[9px] font-bold tracking-tighter px-0.5 pointer-events-none text-white drop-shadow-sm">
                  {Math.round(pct)}%
                </span>
              )}
            </button>
          );
        })}
      </div>
      {!compact && (
        <div className="flex items-center gap-4 mt-1.5">
          {sorted.map((s) => (
            <button
              key={s.severity}
              type="button"
              onClick={() => setSelectedDetail({ type: "severity", payload: { severity: s.severity, count: s.count } })}
              className="flex items-center gap-1.5 hover:opacity-80"
            >
              <span className="w-1.5 h-1.5" style={{ background: SEV_COLOR[s.severity] }} />
              <span className="label-micro capitalize">{s.severity}</span>
              <span className="text-[10px] font-display text-[var(--text-primary)]">{s.count}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
